import { Laptop, Smartphone } from "lucide-react";
import { getDeviceKindFromUserAgent } from "./userAgentDevice";

type Props = {
  userAgent?: string | null;
  className?: string;
  iconClassName?: string;
};

/**
 * Shows a phone or laptop icon from User-Agent; full string in tooltip.
 */
export function UserAgentDeviceBadge({
  userAgent,
  className = "",
  iconClassName = "w-3.5 h-3.5",
}: Props) {
  const kind = getDeviceKindFromUserAgent(userAgent);
  if (!kind) return null;

  const trimmed = userAgent?.trim() ?? "";
  const title = trimmed.length > 0 ? trimmed : kind === "mobile" ? "Mobile" : "Desktop or tablet";
  const label = kind === "mobile" ? "Mobile client" : "Desktop or tablet";

  if (kind === "mobile") {
    return (
      <span className={`inline-flex text-gray-500 ${className}`} title={title} aria-label={label}>
        <Smartphone className={iconClassName} strokeWidth={1.75} />
      </span>
    );
  }

  return (
    <span className={`inline-flex text-gray-500 ${className}`} title={title} aria-label={label}>
      <Laptop className={iconClassName} strokeWidth={1.75} />
    </span>
  );
}
